import PickrController from "./pickr_controller"

# Proxy controller to PickrController in case the Color Picker lib changes
export default class extends PickrController